import { SimpleResult } from '../models/Result';
import { simpleObject } from '../lib/utils';

export function response(data, target, flatten = true) {
  let result = new SimpleResult(data);
  if (flatten) {
    result = simpleObject(result);
  }
  target.postMessage(result, '*');
}



/** WEBPACK FOOTER **
 ** ./~/web-message-helper/src/lib.js
 **/